
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/studio/uxui-improvement",
      function () {
        return require("private-next-pages/services/studio/uxui-improvement.tsx");
      }
    ]);
  